import React, { Component } from 'react';
import {Button, Card, Col, Row} from "antd";
import {Link} from "react-router-dom";
import {injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";

export class CardSecondExtraFunctionalities extends Component {
  constructor(props){
    super(props)

    this.state = {
      getValue : 1
    }; 
  }

  render() {
    const { title, price, addUserPackQty, id, qty, hidden, newColor } = this.props;
    if (hidden) return null;
    return (
      <Card
        size={'small'}
        style={{ borderRadius: 10, background: '#F1FAFF', border: 'none' }}
      >
        <Row>
          <Col span={24} style={{ fontSize: 16, fontWeight: "700", color: "#7E7E7E" }}>
            {title}
          </Col>
        </Row>
        <Row gutter={[10,10]} type={'flex'} align={'middle'} justify={'space-between'}>
          <Col span={12}>
            <Link to={'/'} style= {{fontSize: 15, fontWeight: "700", color: newColor}}>Por solo ${price} al mes</Link>
          </Col>
          <Col span={7}>
            <div style={{ display: 'flex', justifyContent: 'space-between', width: 100, margin: '0 auto' }}>
              <Button
                type={'primary'}
                style={{ margin: '0 auto', display: 'block', width: 27, }}
                size={'small'}
                onClick={() => { addUserPackQty(id,-1) }}
              >
                <span><img src="/images/img_v2/icon-btn-minus.svg" alt='filtro'/></span>
              </Button>
              <Button
                style={{ margin: '0 auto', display: 'block', }}
                size={'small'}
              >
                { qty}
              </Button>
              <Button
                type={'primary'}
                style={{ margin: '0 auto', display: 'block', width: 27, padding: '0 4px' }}
                size={'small'}
                onClick={() => { addUserPackQty(id,1) }}
              >
                <span><img src="/images/img_v2/icon-btn-add.png" alt='filtro'/></span>
              </Button>
            </div>
          </Col>
          
        </Row>
      </Card>
    )
  }
}

const mapStateToProps = state => {
  return {
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
  }
}

const mapDispatchToProps = {
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(CardSecondExtraFunctionalities)))
